import { Component, inject, OnDestroy, OnInit, signal, WritableSignal, ChangeDetectionStrategy } from "@angular/core";
import { ServiceListComponent } from "../../../../shared/widgets/service-list/service-list.component";
import { ASSET_TYPES } from "../../../../enums/assetTypes.enum";
import { GateFaultTableComponent } from "../../../../shared/widgets/gate-fault-table/gate-fault-table.component";
import { ExpectedEnergyLossComponent } from "../../../../shared/widgets/expected-energy-loss/expected-energy-loss.component";
import { EnergyLossYearlyChartComponent } from "../../../../shared/widgets/energy-loss-yearly-chart/energy-loss-yearly-chart.component";
import { CustomerMapComponent } from "../../../../shared/widgets/customer-map/customer-map.component";
import { AuthService } from "../../../../services/api/auth/auth.service";
import { first } from "rxjs";
import { CustomerHomeService } from "./facade/customer-home.service";
import { SimplebarAngularModule } from "simplebar-angular";
import { SeverityOverview } from "../../../../shared/widgets/severity-overview/severity-overview";

@Component({
  standalone: true,
  selector: "app-customer",
  imports: [
    ServiceListComponent,
    CustomerMapComponent,
    GateFaultTableComponent,
    ExpectedEnergyLossComponent,
    EnergyLossYearlyChartComponent,
    SimplebarAngularModule,
    SeverityOverview,
  ],
  templateUrl: "./customer.component.html",
  styleUrl: "./customer.component.scss",
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [CustomerHomeService],
})
export class CustomerComponent implements OnInit, OnDestroy {
  public assetTypes = ASSET_TYPES;
  public customerId: WritableSignal<string | null> = signal(null);

  private authService = inject(AuthService);
  public customerHomeFacade = inject(CustomerHomeService);

  public ngOnInit() {
    this.authService
      .getAuthenticatedUser()
      .pipe(first())
      .subscribe((user) => {
        const customerId = user?.customer?.id;
        if (customerId) {
          this.customerId.set(customerId);

          this.customerHomeFacade.loadInitialState(customerId);
        }
      });
  }

  public ngOnDestroy() {
    this.customerHomeFacade.destroy();
  }
}
